import { useCoachMark } from '#hooks/useCoachMark';
import { PropsWithChildren } from 'react';

interface SpotLightProps extends PropsWithChildren {
  style?: React.CSSProperties;
}

const CoachMarkSpotLight = ({ children, style = {} }: SpotLightProps) => {
  const { isCoachMark, setCoachMark } = useCoachMark();

  if (!isCoachMark) return <>{children}</>;

  return (
    <div
      onClick={() => setCoachMark(false)}
      className="relative border-solid boder-1 rounded-20 bg-[#1E1B24]"
      style={{
        zIndex: isCoachMark ? '1000' : '0',
        ...style
      }}
    >
      {children}
    </div>
  );
};

export default CoachMarkSpotLight;
